import { useState } from "react";
import { Button } from "react-bootstrap";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AddNewNestedTabDialog from "./add-new-nested-tab-dialog";

const AddNewNestedTabButton = () => {
  const [showAddNewDialog, setShowNewDialog] = useState(false);
  const toggleAddNewDialog = () => setShowNewDialog(!showAddNewDialog);
  return (
    <>
      <Button
        as="div" // to avoid validateDOMNesting warning
        size="sm"
        variant="primary"
        className="py-0 px-1 border-0 rounded"
        onClick={toggleAddNewDialog}
      >
        <FontAwesomeIcon size="sm" icon={faAdd} />
      </Button>
      {showAddNewDialog && (
        <AddNewNestedTabDialog
          show={showAddNewDialog}
          toggleDialog={toggleAddNewDialog}
        />
      )}
    </>
  );
};
export default AddNewNestedTabButton;
